import { render, staticRenderFns } from "./AdminShortenUrls.vue?vue&type=template&id=b2c745f2"
import script from "./AdminShortenUrls.vue?vue&type=script&lang=js"
export * from "./AdminShortenUrls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports